import { useOrganization } from "@api/organization.api";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { CreateOrganizationFlow } from "@components/onboarding/flows/CreateOrganizationFlow";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useEffect } from "react";

export const CreateOrganizationRoute = () => {
    const { toast } = useToaster();
    const { data: organization, isFetched } = useOrganization();
    const navigate = useStateAwareNavigate();

    useEffect(() => {
        if (!isFetched) {
            return;
        }

        if (organization) {
            toast("This user already has access to an organization");

            navigate("/", {
                replace: true,
            });
        }
    }, [organization, navigate, isFetched, toast]);

    if (!isFetched) {
        return <PageCoverLoader />;
    }

    return <CreateOrganizationFlow />;
};
